import { Controller } from '@hotwired/stimulus'
import { hideElement, showElement } from 'utils/toggle_element_visibility'
import { addClass, removeClass } from "utils/toggle_class"
import AudioPlayer from 'utils/audio_player'
import Timer from 'utils/timer'

export default class extends Controller {
  static targets = ["playAction", "pauseAction", "stopAction", "time", "reset"]

  static values = {
    time: Number,
    audioUrl: String
  }

  initialize() {
    this.timer = new Timer(this.element, this.timeTarget, this.timeValue)
    this.timerIsRunning = false

    this.audioPlayer = new AudioPlayer()
    this.audioPlayer.setAudioFile(this.audioUrlValue)
  }

  repeat() {
    this.stop()
    this.play()
  }

  play() {
    showElement(this.pauseActionTarget)
    removeClass(this.resetTarget, "disable")
    hideElement(this.playActionTarget)

    this.timer.start()

    if (!this.timerIsRunning) {
      this.timerIsRunning = true
      this.timer.init()
    }
  }

  pause() {
    hideElement(this.pauseActionTarget)
    showElement(this.playActionTarget)

    this.timer.pause()
  }

  stop() {
    hideElement(this.stopActionTarget)
    addClass(this.resetTarget, "disable")
    showElement(this.playActionTarget)
    removeClass(this.element, "-finish")

    this.timer.stop()
    this._stopPromptAudio()
  }

  finish() {
    hideElement(this.pauseActionTarget)
    showElement(this.stopActionTarget)
    addClass(this.element, "-finish")

    this.timerIsRunning = false

    this.audioPlayer.play() // play initial chime immediately after 0 then 5 second interval
    this.promptAudioInterval = setInterval(() => { this.audioPlayer.play() }, 5000)
  }

  _stopPromptAudio() {
    clearInterval(this.promptAudioInterval)
  }
}
